/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { icons } from "../const/icons";
import { Table, Button, Row, Col, Switch, Input, Space, Modal } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { GetFetchPais } from "../Api/Administracion/GetFetchPais";
import { PutFetchPais } from "../Api/Administracion/PutFetchPais";

import "react-datepicker/dist/react-datepicker.css";
import "../theme/AdministracionCatalogo.css";
import "../theme/Pagination.css";
import RemitenteAddForm from "./Modals/Remitentes/RemitenteAdd";
import useGet from "../hooks/useGet";
import { UseAdmin } from "../hooks";
import UsePermissions from "../hooks/usePermissions";
import createAxiosInstanceNew from "../Api/AxiosInstance/AxiosInstance";

export const TableAdministracionRemitentes = () => {
  const { brandfiMarcaId } = UseAdmin();

  const { hasAllPermissionsChild1, hasAllBrandsViewChild1 } = UsePermissions();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [datosfaltantes, setDatosfaltantes] = useState([]);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (brandfiMarcaId || refetch) {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const axiosInstance = await createAxiosInstanceNew();
          const response = await axiosInstance.get("faltante/remitente", {
            params: {
              FIPAISID: 1,
              ...(!hasAllPermissionsChild1 &&
                !hasAllBrandsViewChild1 && { FIMARCAID: brandfiMarcaId }),
            },
          });

          if (response.data.statusCode === 200) {
            setDatosfaltantes(response.data.body);
          }
        } catch (err) {
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      };

      fetchData();
    }
  }, [brandfiMarcaId, hasAllPermissionsChild1, hasAllBrandsViewChild1, refetch]);

  const triggerRefetch = () => {
    setRefetch(!refetch);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    const onFailure = (error) => {
      setIsLoading(false);
    };

    const onSuccess = ({ data }) => {
      setData(data.body.data);
      setIsLoading(false);
    };

    GetFetchPais(false).then(onSuccess).catch(onFailure);
  };

  const handleOpenModal = (dato) => {
    setSelectedItem(dato);
    setShowModal(true);
    setModalKey(modalKey + 1); // Cambiar el valor de modalKey cada vez que se abre el modal
    setIsEdit(true);
  };

  const handleAdd = () => {
    setSelectedItem(null);
    setShowModal(true);
    setModalKey(modalKey + 1); // Cambiar el valor de modalKey cada vez que se abre el modal
  };

  const isBranchAlreadyCreated = (branchId) => {
    return datosfaltantes?.some((item) => item.FIMARCAID === branchId);
  };

  const HandleSwitch = ({ value, all }) => {
    const [hs, setHs] = useState(parseInt(value) === 1);
    const handleChangeSwitch = (v) => {
      setIsLoading(true);
      const newObj = {
        FIPAISID: parseInt(all.FIPAISID),
        FCNOMBRE: all.FCNOMBRE,
        FIESTATUSID: v ? 1 : 0,
      };

      //peticion....
      const onFailure = (error) => {
        setIsLoading(false);
        alert(error);
      };
      const onSuccess = ({ data }) => {
        setIsLoading(false);
        // eslint-disable-next-line no-lone-blocks
        if (data.statusCode === 201) {
          fetchData();
          //alert("Envio exitoso");
        } else {
          alert(data.error);
        }
      };
      PutFetchPais(newObj).then(onSuccess).catch(onFailure);

      setHs(v);
    };
    return <Switch checked={hs} value={hs} onChange={handleChangeSwitch} />;
  };

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  /*const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };*/

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          {/*           <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpiar
          </Button>*/}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Pais",
      dataIndex: "FIPAISID",
      key: "FIPAISID",
      render: (item) => item === 1 && "MÃ©xico",
      // ...getColumnSearchProps("FIPAISID"),
    },
    {
      title: "Marca",
      dataIndex: "FCNOMBREMARCA",
      key: "FCNOMBREMARCA",
      ...getColumnSearchProps("FCNOMBREMARCA"),
    },
    // {
    //   title: "Sucursal",
    //   dataIndex: "FISUCURSALID",
    //   key: "FISUCURSALID",
    //   ...getColumnSearchProps("FISUCURSALID"),
    // },
    {
      title: "Remitentes",
      dataIndex: "FCLISTAREMITENTES",
      key: "FCLISTAREMITENTES",
      ...getColumnSearchProps("FCLISTAREMITENTES"),
      width: "25%",
    },
    {
      title: "Editar",
      render: (item) => (
        <button
          onClick={() => handleOpenModal(item)}
          className="button-styles-detalais-catalogo btn-edit-store"
        >
          <img src={icons.edit} alt="Editar" className="edit-icon" />
        </button>
      ),
      fixed: "right",
      width: "10%",
    },
  ];

  return (
    <>
      <Row justify="center">
        <Col xs={11} md={18} className="mt-3" al></Col>
        <Col xs={11} md={4} className="mt-3" al>
          <Button type="primary" onClick={handleAdd} className="button-styles-add-element">
            Agregar Remitente
          </Button>
        </Col>
      </Row>
      <Row justify="center">
        <Col span={22} className="mt-3">
          <Table
            dataSource={datosfaltantes}
            rowKey={"FIMARCAID"}
            columns={columns}
            loading={isLoading}
            scroll={{ x: 1000, y: 600 }}
          />
        </Col>
      </Row>
      <>
        <RemitenteAddForm
          showModal={showModal}
          setShowModal={setShowModal}
          setIsEdit={setIsEdit}
          selectedItem={selectedItem}
          isEdit={isEdit}
          refetch={triggerRefetch}
          isBranchAlreadyCreated={isBranchAlreadyCreated}
        />
      </>
    </>
  );
};
